import { render, staticRenderFns } from "./breadcrumb-item.vue?vue&type=template&id=fcf9eaac&"
import script from "./breadcrumb-item.vue?vue&type=script&lang=js&"
export * from "./breadcrumb-item.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data/builds/MWmsPKDH/0/framework/qmai-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('fcf9eaac')) {
      api.createRecord('fcf9eaac', component.options)
    } else {
      api.reload('fcf9eaac', component.options)
    }
    module.hot.accept("./breadcrumb-item.vue?vue&type=template&id=fcf9eaac&", function () {
      api.rerender('fcf9eaac', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "packages/breadcrumb/src/breadcrumb-item.vue"
export default component.exports